import { render, staticRenderFns } from "./InternationalLogistics.vue?vue&type=template&id=3f0dfe56&scoped=true"
import script from "./InternationalLogistics.vue?vue&type=script&lang=js"
export * from "./InternationalLogistics.vue?vue&type=script&lang=js"
import style0 from "./InternationalLogistics.vue?vue&type=style&index=0&id=3f0dfe56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0dfe56",
  null
  
)

export default component.exports